module.exports = __webpack_public_path__ + "img/salebox-divide-amount-icon.20c268f9.png";